<template>
  <div class="tabs">
    <div class="tabs-header">
      <button
        class="previous"
        :class="{active: activeTab === 'previous'}"
        @click="activeTab = 'previous'"
      >
        Added keyword ideas
      </button>
      <button
        class="suggestion"
        :class="{active: activeTab === 'suggested'}"
        @click="activeTab = 'suggested'"
      >
        Suggested keywords
      </button>
    </div>
    <div class="tabs-body">
      <div
        v-if="activeTab === 'previous'"
        class="tab-content previous"
      >
        <topics
          :topics="previousTopics"
          @remove-topic="(prevKeyword) => deleteKeyword(prevKeyword.keyword_topic)"
          @select-topic="(prevKeyword) => setFilter({key: 'keywordFilter', value: prevKeyword.keyword_topic})"
        >
          <template #topics-empty>
            <div class="no_topics">
              No previous ideas added
            </div>
          </template>
        </topics>
      </div>

      <div
        v-else-if="activeTab ==='suggested'"
        class="tab-content suggestion"
      >
        <topics
          :topics="uniqueSuggestedTopics"
          :filtering="false"
          :removable="false"
          type="suggestion"
          value-key="keyword"
          @select-topic="(topic) => addSuggestedTopic(topic)"
        >
          <template #topics-empty>
            <div
              v-if="!user.active_website.industry"
              class="text-center py-2"
            >
              To generate keyword suggestions you need to first set an industry for your website, this can be done from your
              <a :href="`/website/settings/${user.active_website.hash_id}`">website settings</a> page.
            </div>
            <div
              v-else
              class="no_topics"
            >
              <div class="py-3 flex-column justify-content-center align-items-center text-center">
                <div v-if="generatingSuggestedTopics">
                  Generating keyword suggestions...
                </div>
                <button
                  v-else
                  class="generate_button"
                  @click="generateSuggestedTopics"
                >
                  <span>
                    <svg-vue icon="icons/arrows-counter-clockwise" />
                  </span>
                  Generate Keyword Suggestions
                </button>
              </div>
            </div>
          </template>
        </topics>
      </div>
    </div>
  </div>
</template>

<script>
import Topics from './Topics.vue';
import {mapActions, mapGetters} from 'vuex';

export default {
  components: {
    Topics
  },
  emits: ['error'],
  data() {
    return {
      activeTab: 'previous',
    }
  },
  computed: {
    ...mapGetters('user', [
        'user'
    ]),
    ...mapGetters('keywordIdeas', [
      'chosenKeywords',
      'previousTopics',
      'suggestedTopics',
      'suggestions',
      'keywordFilter',
      'generatingSuggestedTopics',
    ]),
    uniqueSuggestedTopics() {
      return this.suggestedTopics.filter((topic) =>
          !this.previousTopics.find(previous => previous.keyword_topic.toLowerCase() === topic.keyword.toLowerCase())
      );
    },
  },
  watch: {
    keywordFilter(newValue) {
      if (newValue !== null) {
        this.activeTab = 'previous'
      }
    },
  },
  mounted() {
    if (this.previousTopics.length <= 0 && this.suggestedTopics.length >= 1) {
      this.activeTab = 'suggested';
    }
  },
  methods: {
    ...mapActions('keywordIdeas', [
      'setFilter',
      'addKeywordSuggestion',
      'removePreviousKeyword',
      'generateSuggestedTopics',
    ]),
    async addSuggestedTopic(suggestedTopic) {
      const keyword = suggestedTopic.keyword.trim().toLowerCase();
      let exists = this.previousTopics.find(topic => topic.keyword_topic === keyword);

      let tab = 'previous';
      let error = null;
      let serverError = false;
      if (! exists) {
        try {
          const suggestionCount = await this.addKeywordSuggestion(suggestedTopic.keyword);
          if (!suggestionCount || suggestionCount === 0) {
            error = 'We found no suggestions for this keyword. Please try another keyword';
          }
        } catch (e) {
          tab = 'suggested';
          error = 'Something went wrong selecting suggested keyword, please try again.';
          serverError = true;
        }
      }

      this.$emit('error', error);
      this.activeTab = tab;

      if (! serverError) {
        this.setFilter({key: 'keywordFilter', value: keyword});
      }
    },
    deleteKeyword(keyword) {
      this.removePreviousKeyword(keyword);
    }
  }
}
</script>

<style lang="scss" scoped>
.no_topics {
  margin-top: 1rem;
  text-align: center;
  color: var(--primary-font-color);
}

.tab-content {
  &.suggestion {
    .no_topics {
      margin-top: 0;
      color: var(--secondary-color);

      .generate_button {
        display: flex;
        width: 100%;
        justify-content: center;
        align-items: center;

        &:hover,
        &:active {
          color: var(--secondary-color-dark);
        }

        span {
          width: 18px;
          height: 18px;
          margin-right: 5px;
        }
      }
    }
  }
}
</style>
